<i class="fa fa-star" [class]="iconClass" [title]="title" (click)="onClick()"></i>

<ng-template #favDescTmpl>
  <ul style="max-height: 75vh; overflow: auto;">
    <label class="w-100">Description:
    <input type="text" [(ngModel)]="descr" class="focused-initially">
    </label>
  </ul>
</ng-template>